<template>
    <div :class="{'en': lang === 'en'}">
        <div class="card-title">
            {{ $t("lang.update_summary") }}
        </div>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="summary.creditCard" style="width: 100%" type="number" :placeholder="$t('lang.credit_card')"></vs-input>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="summary.fixedCustody" type="number" style="width: 100%" :placeholder="$t('lang.fixed_custody')"></vs-input>
                </div>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-1">
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="summary.currentCustody" type="number" style="width: 100%" :placeholder="$t('lang.current_custody')"></vs-input>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="input-group">
                    <vs-input v-model="summary.fixedReturn" type="number" style="width: 100%" :placeholder="$t('lang.fixed_return')"></vs-input>
                </div>
            </vs-col>
        </vs-row>
        <vs-row class="m-t-2">
            <vs-col vs-w="12" vs-type="flex" vs-justify="center">
                <vs-button size="small" color="rgb(37, 105, 193)" class="stribtn m-r-1" @click="onUpdate()">{{$t('message.submit')}}</vs-button>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
export default {
    props: ["data"],
    data(){
        return{
            lang: '',
            token: '',
            format: 'dd / MM / yyyy',
            highlight: {
                customPredictor(date) {
                    if ((date.getDate() - new Date().getDate() == 0) && (date.getMonth() - new Date().getMonth() == 0))
                        return true;
                }
            },
            summary: { ...this.data },
        }
    },
    created() {
        this.lang = this.$cookies.get('lang');
        this.token = this.$cookies.get('token');
    },
    watch:{
        "data"(newVal){
            this.summary = newVal;
        },
    },
    methods: {
        onUpdate(){
            this.$emit("update", this.summary);
        },
    },
}
</script>

<style scoped>
.input-group {
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: 10px;
}
label{
    margin-bottom: 0;
    white-space: nowrap;
    width: 100px;
}
.en label{
    width: 180px;
}
</style>
